function clickHandler( e: MouseEvent ): void {
	// Only listen to button clicks.
	if ( !e || !e.target || !( e.target instanceof HTMLElement ) ) {
		return;
	}

	// Only listen to product teaser color button clicks.
	if ( !e.target.hasAttribute( 'product-teaser-color-button' ) ) {
		return;
	}

	// Only proceed if button has 'for' attribute.
	const forId = e.target.getAttribute( 'for' );
	if ( !forId ) {
		return;
	}

	// Only proceed if 'for' points to an existing picture element.
	const forEl = document.getElementById( forId );
	if ( !forEl || !( forEl instanceof HTMLElement ) ) {
		return;
	}

	// Make sure we only do changes in the current teaser.
	const forElParent = forEl.closest( '[product-teaser]' );
	if ( !forElParent || !( forElParent instanceof HTMLElement ) ) {
		return;
	}

	// 1. Hide all color thumbnails inside the parent (we know for sure there is at least one, should always be multiple).
	forElParent.querySelectorAll( '[product-teaser-color-thumbnail]' ).forEach( ( thumbnail ) => {
		thumbnail.setAttribute( 'visually-hidden', '' );
	} );

	// 2. Unselect all color buttons inside the parent (we know for sure there is at least one, should always be multiple).
	forElParent.querySelectorAll( '[product-teaser-color-button]' ).forEach( ( button ) => {
		button.removeAttribute( 'selected' );
	} );

	// 3. Re-show only the triggered thumbnail.
	forEl.removeAttribute( 'visually-hidden' );

	// 4. Re-select the clicked button.
	e.target.setAttribute( 'selected', '' );
}

window.addEventListener( 'click', clickHandler );
